import { React } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import axios from '../../axios';

export default function ResetPasswordStepOne({changeStep}) {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required')
  });

  const sendResetRequest = (values, setSubmitting) => {
    axios.post('/forgot-password', values)
    .then((response) => {
      if (response.data) {
        if (response.status === 200) {
          toast.success(response.data.message);
          changeStep(response.data.email);
        } else {
          toast.warn('No response from server');
        }
      }
      setSubmitting(false);
    })
    .catch((error) => {
      if (error.response?.data?.email) {
        toast.error('This email is not registered'); 
      } else {
        toast.error('Something went wrong');
      }
      setSubmitting(false);
    })
  };

  return (
    <div className='reset-pass-step1'>
        <h1 className='mb-4'>Reset Password</h1>
        <Formik
          initialValues={{
            email: ''
          }}
          validationSchema={validationSchema}
          onSubmit={(values, {setSubmitting}) => sendResetRequest(values, setSubmitting)}
        >
          {({
            values,
            handleChange,
            handleSubmit,
            isSubmitting
          }) => (
            <Form className='forms'onSubmit={handleSubmit}>
              <div className='mb-3'>
                <Form.Label>Enter Registered Email</Form.Label>
                <Form.Control
                  type='email'
                  name='email'
                  placeholder='Enter your registered email'
                  value={values.email}
                  onChange={handleChange}
                  disabled={isSubmitting} 
                />
                <ErrorMessage name='email' component='p' className='error-message' />
              </div>
              <Button type='submit' variant='primary' className='btn-full-width my-3' disabled={isSubmitting}>
                Submit 
                {
                  isSubmitting &&
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className='ms-2'
                    />
                }
              </Button>
            </Form>
          )}
        </Formik>
    </div>
  )
}
